import '../attachment/Hamburger.css';
import hamburger from '../assets/Navbar/icons8-menu-50.png';
import close from '../assets/Navbar/icons8-close-50-white.png';

export default function Hamburger() {
    return (
        <div className='Hamburger'>
            <nav>
                <input type='checkbox' id='sidebar-active'></input>
                <label for='sidebar-active' className='Open-sidebar-button'>
                    <img src={hamburger} className="Nav-icon" alt="hamburger" />
                </label>
                <label id='overlay' for='sidebar-active'></label>
                <div className='links-container'>
                    <label for='sidebar-active' className='Close-sidebar-button'>
                        <img src={close} className="Nav-icon" alt="close" />
                    </label>
                    <a href='/home'>Home</a>
                    <a href="https://github.com/Polymatio">GitHub</a>
                    <a href="https://calendly.com/jesus-prras/coffee-chat">Calendly</a>
                    <a href="https://twitter.com/Polymath_Jesus">Twitter</a>
                    <a href="https://www.linkedin.com/in/jp-devs/">LinkedIn</a>
                    <a href='/about'>Meet Me</a>
                </div>
            </nav>
        </div>
    )
}
